import { DomApplier } from '../cssFeatures.types'
import {
	FOCUS_STATE,
	SIBLING_FOCUS,
	BASE_SELECTOR,
	KEYBOARD_TABBING,
	INNER_FOCUS,
	KEYBOARD_ONLY,
	outlineFocusRingStyles,
	innerOutlineFocusRingStyles,
	boxShadowFocusRingStyles,
	innerBoxShadowFocusRingStyles,
} from './accessibilityStyle.constants'

export const buildFocusSelector = (base: string, componentSelector: string = '') => {
	const selector = `${base} ${componentSelector}${FOCUS_STATE}`
	return `${selector}, ${selector}${SIBLING_FOCUS}`
}

export const FOCUS_SELECTOR = buildFocusSelector(BASE_SELECTOR, `:not(${KEYBOARD_ONLY})`)
export const INNER_FOCUS_SELECTOR = buildFocusSelector(BASE_SELECTOR, `${INNER_FOCUS}:not(${KEYBOARD_ONLY})`)

export const KEYBOARD_ONLY_FOCUS_SELECTOR = buildFocusSelector(`${BASE_SELECTOR}${KEYBOARD_TABBING}`, KEYBOARD_ONLY)
export const KEYBOARD_ONLY_INNER_FOCUS_SELECTOR = buildFocusSelector(
	`${BASE_SELECTOR}${KEYBOARD_TABBING}`,
	`${KEYBOARD_ONLY}${INNER_FOCUS}`
)

export const OUTLINE_FOCUS_ON = {
	[FOCUS_SELECTOR]: outlineFocusRingStyles,
	[INNER_FOCUS_SELECTOR]: innerOutlineFocusRingStyles,
	[KEYBOARD_ONLY_FOCUS_SELECTOR]: outlineFocusRingStyles,
	[KEYBOARD_ONLY_INNER_FOCUS_SELECTOR]: innerOutlineFocusRingStyles,
}

export const BOX_SHADOW_FOCUS_ON = {
	[FOCUS_SELECTOR]: boxShadowFocusRingStyles,
	[INNER_FOCUS_SELECTOR]: innerBoxShadowFocusRingStyles,
	[KEYBOARD_ONLY_FOCUS_SELECTOR]: boxShadowFocusRingStyles,
	[KEYBOARD_ONLY_INNER_FOCUS_SELECTOR]: innerBoxShadowFocusRingStyles,
}

export const accessibilityDomApplier: DomApplier<'accessibility'> = (_, __, ___, { accessibilityStyle }) => {
	if (accessibilityStyle.visualFocusDisabled) {
		return null
	}

	return accessibilityStyle.useOutlineFocusRing ? OUTLINE_FOCUS_ON : BOX_SHADOW_FOCUS_ON
}
